module.exports = __webpack_public_path__ + "img/14.068545c8.jpg";